<template>
    <div class="page-home split-view grid grid__split">
        <!-- mobile -->
        <transition v-if="isMobile" name="trs-home-intro-toggle" mode="out-in">
            <div class="page-home--content split-view--content split-view--content__mobile"
                    v-if="!isCollapsed" key="intro">
                <!-- loader -->
                <transition name="trs-wave-loader-fade">
                    <div class="split-view--loader" v-if="isLoading">
                        <cmp-wave-loader></cmp-wave-loader>
                    </div>
                </transition>

                <transition name="trs-placeholder-content-fade">
                    <div v-if="!isLoading" class="page-home--inner split-view--inner">
                        <cmp-home-placeholder :container="containers.home"></cmp-home-placeholder>
                    </div>
                </transition>
            </div>
            <div class="page-home--map-nav trs-page-home--map-nav" v-if="isCollapsed && isHome" key="nav">
                <cmp-map-nav class="map--map-nav" facet="mobile"></cmp-map-nav>
            </div>
        </transition>

        <!-- mobile -->
        <transition v-if="isMobile" name="trs-simple-fade">
            <div v-if="!isCollapsed" class="page-home--intro-toggle" :style="[scrollLockStyles]">
                <cmp-home-intro-toggle></cmp-home-intro-toggle>
            </div>
        </transition>

        <!-- desktop -->
        <div v-if="!isMobile" class="page-home--content split-view--content split-view--content__desktop">
            <div class="split-view--header">
                <div class="grid--container split-view--container">
                    <cmp-main-nav class="split-view--nav" facet="split"></cmp-main-nav>
                </div>
            </div>

            <!-- loader -->
            <transition name="trs-wave-loader-fade">
                <div class="split-view--loader" v-if="isLoading">
                    <cmp-wave-loader></cmp-wave-loader>
                </div>
            </transition>

            <div class="split-view--inner">
                <cmp-home-placeholder :container="containers.home" :is-loading="isLoading"></cmp-home-placeholder>
            </div>

            <div class="page-home--intro-scroller">
                <cmp-home-intro-scroller :first-location="routeData.first_location"></cmp-home-intro-scroller>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import routeMixin from 'framework/mixins/route';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';

    export default {
        mixins: [
            routeMixin,
            isMobileMixin,
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['viewport', 'isHomeIntroDismissed']),
            isCollapsed() {
                return this.isMobile && this.isHomeIntroDismissed;
            },
            isHome() {
                return this.pageType === 'page-home';
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/pages/home/index.vue?6547bec1